<template>
  <div class="fieldItemClass">
    <el-row :gutter="20" style="width: 100%">
      <el-form
        ref="ruleForm"
        class="dialog-form"
        :rules="rules"
        :model="form"
        :label-suffix="':'"
      >
        <template v-for="(item, index) in formColumn">
          <el-col
            :span="item.fieldType == 'text' ? 24 : 12"
            :key="index"
            v-if="item.formVisible == 'Y' || false"
          >
            <el-form-item :label="item.fieldDesc" :prop="item.fieldName">
              <!-- 单选 -->
              <div v-if="item.fieldType === 'dropdown'">
                <el-select
                  v-if="
                    item.fieldName == 'levyCompany' ||
                    item.fieldName == 'withheldCompany' ||
                    item.fieldName == 'laborCompanyName'"
                  :ref="item.fieldName"
                  v-model="form[item.fieldName]"
                  :name="item.fieldName"
                  :placeholder="
                    item.tipText ? item.tipText : '请选择' + item.fieldDesc
                  "
                  :disabled="isEdit || false"
                  filterable
                  :clearable="item.isRequired != 'Y'"
                  size="small"
                >
                  <el-option
                    v-for="dict in item.dataSource"
                    :key="dict.guid"
                    :label="dict.tenantName"
                    :value="dict.tenantName"
                  >
                  </el-option>
                </el-select>
                <!-- :disabled="item.fieldDesc=='在职状态'"u -->
                <el-select
                  v-else
                  :ref="item.fieldName"
                  v-model="form[item.fieldName]"
                  :name="item.fieldName"
                  :placeholder="
                    item.tipText ? item.tipText : '请选择' + item.fieldDesc
                  "
                  filterable
                  :clearable="item.isRequired != 'Y'"
                  size="small"
                  :disabled="item.fieldName == 'dutyStatus'||item.fieldName == 'staffLevel' || isEdit || false"
                  @change="changeDropdown(item, form[item.fieldName])"
                >
                  <el-option
                    v-for="dict in item.dataSource"
                    :key="dict.value"
                    :label="dict.name"
                    :value="dict.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <!-- 多选 -->
              <el-select
                v-else-if="item.fieldType === 'dropdownlist'"
                :ref="item.fieldName"
                v-model="form[item.fieldName]"
                :name="item.fieldName"
                :placeholder="
                  item.tipText ? item.tipText : '请选择' + item.fieldDesc
                "
                :disabled="isEdit || false"
                filterable
                :clearable="item.isRequired != 'Y'"
                size="small"
                multiple
                collapse-tags
                reserve-keyword
              >
                <el-option
                  v-for="dict in item.dataSource"
                  :key="dict.value"
                  :label="dict.name"
                  :value="dict.value"
                >
                </el-option>
                <i
                  v-if="item.requestUrl"
                  slot="prefix"
                  class="el-input__icon el-icon-search"
                />
              </el-select>
              <!-- 日期 -->
              <el-date-picker
                v-else-if="item.fieldType === 'date'"
                v-model="form[item.fieldName]"
                value-format="yyyy-MM-dd"
                :disabled="isEdit || item.disabled || false"
                :clearable="item.isRequired != 'Y'"
                size="small"
                type="date"
                :placeholder="
                  item.tipText ? item.tipText : '请选择' + item.fieldDesc
                "
              />
              <!-- 文件 -->
              <!-- 如果是文件 -->
              <div v-else-if="item.fieldType === 'img'">
                <!-- 展示上传组件 -->
                <!--beforeAvatarUpload文件的大小设定  -->
                <!--:http-request="(file) => { return uploadImage(file, item.fieldName) }"上传到服务器  -->
                <el-upload
                  v-if="!isEdit || !form[item.fieldName]"
                  :ref="'uploadImg_' + item.fieldName"
                  class="avatar-uploader"
                  action="#"
                  :disabled="isEdit || false"
                  :limit="1"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :http-request="
                    (img) => {
                      return uploadImage(img, item.fieldName);
                    }
                  "
                >
                  <i
                    v-if="!form[item.fieldName]"
                    class="el-icon-plus avatar-uploader-icon"
                  ></i>
                  <!-- 解析JSON字符串,得到文件名 -->
                  <el-tooltip
                    v-else
                    class="item"
                    effect="dark"
                    :content="JSON.parse(form[item.fieldName]).fileName"
                    placement="top-start"
                  >
                    <!-- <img v-if="form[item.fieldName].indexOf('.xls') != -1 || form[item.fieldName].indexOf('.xlsx') != -1"
                      :src="excelIcon" alt="" class="avatar">
                    <img
                      v-else-if="form[item.fieldName].indexOf('.doc') != -1 || form[item.fieldName].indexOf('.docx') != -1"
                      :src="wordIcon" alt="" class="avatar"> -->
                    <img
                      :src="form[item.fieldName] | filterFile"
                      class="avatar"
                    />
                  </el-tooltip>
                </el-upload>
                <el-image
                  v-else
                  class="previewImg"
                  ref="myImg"
                  :src="form[item.fieldName] || filterFile"
                  :preview-src-list="previewList"
                  @click="getPreviewList(item.fieldName)"
                >
                </el-image>
              </div>
              <div v-else-if="item.fieldType === 'file'" class="fileClass">
                <el-upload
                  class="upload-demo t-left"
                  action="#"
                  multiple
                  accept=".pdf,.docx,.doc,.xlsx,.docx,.jpg,.png,.jpeg,.pdf"
                  :on-remove="
                    (fileEvent) =>
                      handleFileRemoveOther(fileEvent, item.fieldName)
                  "
                  :http-request="
                    (fileEvent) => uploadFileOther(fileEvent, item.fieldName)
                  "
                  :file-list="
                    form[item.fieldName] ? JSON.parse(form[item.fieldName]) : []
                  "
                  :beforeUpload="beforeAvatarUploadOther"
                >
                  <div class="file-operate" slot="file" slot-scope="{ file }">
                    <div class="file-name">{{ file.name }}</div>
                    <div
                      class="file-preview"
                      @click="onPreview(item.fieldName)"
                    >
                      查看
                    </div>
                    <div
                      v-if="!isDisabled"
                      class="file-preview"
                      @click="handleSubRemove(file, item.fieldName)"
                    >
                      删除
                    </div>
                    <div
                      class="file-preview"
                      @click="onDownload(item.fieldName)"
                    >
                      下载
                    </div>
                  </div>

                  <div class="import-btn-tips">
                    <el-button
                      size="mini"
                      icon="el-icon-my-import"
                      type="importNew"
                      >导入文件</el-button
                    >
                  </div>
                  <div slot="tip" class="import-step-tip">
                  支持.pdf,.docx,.doc文件，单个文件不得大于20M
                </div>
                </el-upload>
                
              </div>
              <!-- 
              <el-upload v-else-if="item.fieldType === 'file'" :ref="'uploadImg_'+ item.fieldName" class="avatar-uploader" action="#" :disabled="isEdit || false" :limit="1" :show-file-list="false" :before-upload="beforeAvatarUpload"
                  :http-request="(file)=>{return uploadImage(file,item.fieldName)}">
                  <i v-if="!form[item.fieldName]" class="el-icon-plus avatar-uploader-icon"></i>
                  <el-tooltip v-else  class="item" effect="dark" :content="JSON.parse(form[item.fieldName]).fileName" placement="top-start">
                    <img v-if="form[item.fieldName].indexOf('.xls') != -1 || form[item.fieldName].indexOf('.xlsx') != -1" :src="excelIcon" alt="" class="avatar">
                    <img v-else-if="form[item.fieldName].indexOf('.doc') != -1 || form[item.fieldName].indexOf('.docx') != -1" :src="wordIcon" alt="" class="avatar">
                    <img v-else :src="form[item.fieldName] | filterFile" class="avatar">
                  </el-tooltip>
                </el-upload> -->

              <!-- 省市区级联 -->
              <el-cascader
                :ref="'cascader_' + item.fieldName"
                v-else-if="item.fieldType === 'areaselect'"
                :disabled="isEdit || false"
                :options="options"
                class="w100f"
                v-model="form[item.fieldName]"
                @change="getCascaderNode(item.fieldName)"
                :props="{ checkStrictly: false, value: 'label' }"
                filterable
              >
              </el-cascader>

              <!-- 多行文本 -->
              <el-input
                v-else-if="item.fieldType === 'text'"
                :class="{
                  'my-textarea': item.fieldName === 'rewardsPunishment',
                }"
                v-model="form[item.fieldName]"
                type="textarea"
                :disabled="isEdit || false"
                :clearable="item.isRequired != 'Y'"
                :rows="3"
                placeholder="请输入内容"
                :maxlength="item.maxlength || 400"
                :show-word-limit="item.maxlength > 0"
              />

              <!-- 文本 -->
              <el-input
                v-else
                v-model.trim="form[item.fieldName]"
                :placeholder="
                  item.tipText ? item.tipText : '请选择' + item.fieldDesc
                "
                :disabled="
                  item.fieldDesc == '司龄(月)' ||
                  isEdit ||
                  item.disabled ||
                  false
                "
                :clearable="item.isRequired != 'Y'"
                size="small"
                :maxlength="item.maxlength || 40"
              />
            </el-form-item>
          </el-col>
        </template>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import areaJson from "../../assets/js/china_address_v4.js";
import idNumber from "../../assets/js/idNumber.js";
import qs from "qs";
import { route } from "@/api/apiRoute";
export default {
  name: "fieldItem",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    formColumn: {
      type: Array,
      default() {
        return [];
      },
    },
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    guid: {
      type: String,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    //传来的文件
    // otherFile:{
    //   type: Array,
    //   default: () => []
    // }
  },

  data() {
    return {
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      rules: {}, // 表单校验
      excelIcon: require("../../assets/images/excel_icon.png"),
      wordIcon: require("../../assets/images/word_icon.png"),
      previewList: [],
      options: areaJson, //调用外部js文件的json数据
      newForm: null,
      selectedValues: [],
      fileField : [ // !附件字段
        "medicalReport",
        "dimissionReport",
        "contractFile",
        "idFrontPictContent",
        "idBackPictContent",
      ]
    };
  },
  watch: {
    formColumn(newVal, oldVal) {
      if (newVal) {
        this.init();
      }
    },
    form: {
      handler(newVal) {},
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.init();
  },
  computed: {
    isDisabled() {
      // !查看模式
      return this.$route.query.operationMode === "look";
    },
    // currentFormData() {
    //   return function(fieldName) {
    //     console.log(43243);
    //     if (this.form[fieldName]) {
    //       return JSON.parse(this.form[fieldName])
    //     }
    //     return []
    //   }
    // }
  },
  filters: {
    filterFile(val) {
      //处理图片显示
      //是json
      try {
        let obj = JSON.parse(val);
        return obj.path;
      } catch (e) {}
      //不是
      return val;
    },
  },
  // created() {
  //   console.log();
  //   this.gdjs()
  // },
  mounted() {},
  methods: {
    mobilenoFn(rule, value, callback) {
      console.log(value);
      // let query={
      //   idCode:this.form.idCode,
      //   mobilesNos :value,
      //   rosterGuid:this.form.guid
      // }
      // /${serverConfig.msConfigureService}
      this.api
        .postJson(
          `/${serverConfig.msPersonnelService}/staff-roster/check-roster-mobiles?idCode=${this.form.idCode}&mobilesNos=${value}&rosterGuid=${this.form.guid}`
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            console.log(res);
            callback();
          } else {
            callback();
          }
        });
      callback();
    },
    // 初始化校验规则
    selfvalidatorFn(rule, value, callback) {
      if (!value) {
        return callback(new Error("请输入身份证号"));
      }
      if (value && idNumber.cnid(value) === false) {
        callback("身份证信息错误");
      } else {
        callback();
      }
      callback();
    },

    gdjs() {},
    init() {
      let self = this;
      this.rules = {};

      this.formColumn.forEach((oneData) => {
        //处理是否可编辑 'idCode'  'mobileNo'
        if (oneData.fieldName == "idCode") {
          if (this.form["idCode"]) {
            this.$set(oneData, "disabled", true);
          } else {
            this.$set(oneData, "disabled", false);
          }
        }
        if (oneData.fieldName == "birthday") {
          if (this.form["birthday"]) {
            this.$set(oneData, "disabled", true);
          } else {
            this.$set(oneData, "disabled", false);
          }
        }
        if (oneData.fieldName == "staffLevel") {
          console.log( oneData)
          if (this.form["staffLevel"]) {
            this.$set(oneData, "disabled", true);
          } else {
            this.$set(oneData, "disabled", false);
          }
        }
        if (oneData.fieldName == "dutyStatus") {
          if (this.form["dutyStatus"]) {
            this.$set(oneData, "disabled", true);
          } else {
            this.$set(oneData, "disabled", false);
          }
        }

        // 上传组件的临时数组变量,后期有新的上传在新增数组的字段
        const fileUploader = [
          "medicalReport",
          "dimissionReport",
          "contractFile",
          "idFrontPictContent",
          "idBackPictContent",
        ];
        if (fileUploader.includes(oneData.fieldName)) {
          const str_tmp = oneData.fieldName + "_arr";
          self.form[str_tmp] = [];
          // fileUploader.forEach(item => {
          //   // this.$set(oneData, `${item}_arr`, [])
          //   const str_tmp = oneData.fieldName + '_arr'
          //   self.form[str_tmp] = []
          // })
        }

        //只要是 file类型的组件,作为上传的,数据初始化都是一个数组,方便下面push操作
        // if(oneData.fieldType === 'file') {
        //   this.form[oneData.fieldName] = '[]'
        // }

        //处理省市区级联
        if (
          oneData.fieldType === "areaselect" &&
          this.form[oneData.fieldName] &&
          this.form[oneData.fieldName].indexOf("/") > 0
        ) {
          let str = this.form[oneData.fieldName];
          this.form[oneData.fieldName] =
            this.form[oneData.fieldName].split("/");
          this.$nextTick(() => {
            this.getCascaderNode(oneData.fieldName); //获取code
          });
        }

        //获取下拉  levyCompany  代征  withheldCompany 代缴  laborCompanyName 签约参保
        if (oneData.fieldName == "levyCompany") {
          this.getLevyCompanyOption(oneData);
        }
        if (oneData.fieldName == "withheldCompany") {
          this.getWithheldCompanyOption(oneData);
        }
        if (oneData.fieldName == "laborCompanyName") {
          this.getInsuredCompanyOption(oneData);
        }

        // if(oneData.listVisible == 'Y'){
        //添加校验   1.必填
        this.rules[oneData.fieldName] = [];
        if (oneData.isRequired == "Y") {
          let data = {};
          if (oneData.fieldType === "dropdownlist") {
            data = {
              type: "array",
              required: true,
              message: oneData.fieldDesc + "不能为空",
              trigger: "blur",
            };
          } else {
            data = {
              required: true,
              message: oneData.fieldDesc + "不能为空",
              trigger: ["blur", "change"],
            };
          }
          this.rules[oneData.fieldName].push(data);
        }
        //2.正则
        if (oneData.fieldType == "input" && oneData.validRule) {
          let newData = {
            pattern: oneData.validRule,
            message: oneData.fieldDesc + "输入格式不正确！",
            trigger: ["blur", "change"],
          };
          this.rules[oneData.fieldName].push(newData);
        }

        // 3. 身份证
        if (oneData.fieldName == "idCode") {
          let newData = {
            validator: this.selfvalidatorFn,
            message: oneData.fieldDesc + "身份证格式不正确！",
            trigger: "blur",
          };
          this.rules[oneData.fieldName].push(newData);
        }
        // 3. 身份证
        if (oneData.fieldName == "mobileNo") {
          let newData = {
            validator: this.mobilenoFn,
            message: oneData.fieldDesc + "身份证格式不正确！",
            trigger: "blur",
          };
          this.rules[oneData.fieldName].push(newData);
        }
      });
    },
    //返回地址对应的code
    getCascaderNode(name) {
      let str = "cascader_" + name;
      const checkedNodes = this.$refs[str][0].getCheckedNodes();
      let arr = checkedNodes[0].pathNodes;
      let codeArr = [];
      arr.forEach((item) => {
        codeArr.push(item.data.value);
      });
      if (name == "familyRegister") {
        this.form.familyRegisterAddressCode = codeArr.join("/");
      }
      if (name == "liverAddress") {
        this.form.liverAddressCode = codeArr.join("/");
      }
    },
    // 获取签约参保公司字典
    getInsuredCompanyOption(oneData) {
      let data = {
        pageSize: -1,
        pageIndex: 1,
        bizState: "Y",
      };
      this.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, data)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            oneData.dataSource = res.data.data.records
              ? res.data.data.records
              : [];
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 获取代缴公司字典
    getWithheldCompanyOption(oneData) {
      let data = {
        enterpriseType: "9903,9905",
        pageSize: -1,
        pageIndex: 1,
      };
      this.api
        .get(
          `/${
            serverConfig.msCustomerService
          }/delegation-company/list?${qs.stringify(data)}`
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            oneData.dataSource = res.data.data.records;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 获取代征公司字典
    getLevyCompanyOption(oneData) {
      let data = {
        enterpriseType: "9904,9905",
        pageSize: -1,
        pageIndex: 1,
      };
      this.api
        .get(
          `/${
            serverConfig.msCustomerService
          }/delegation-company/list?${qs.stringify(data)}`
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            oneData.dataSource = res.data.data.records;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 附件字段处理 
    fileHanlde(newForm) {
      let rosterParam = JSON.parse(JSON.stringify(newForm))
      for (const key in rosterParam) {
        if (rosterParam.hasOwnProperty.call(rosterParam, key)) {
          if (this.fileField.includes(key)) {
            if (rosterParam[key] && rosterParam[key] === '[]') {
              rosterParam[key] = null
            }
          }
          
        }
      }
      return rosterParam
    },
    //提交保存
    saveForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let newForm = JSON.parse(JSON.stringify(this.form));
          let userInfo = JSON.parse(localStorage.userInfo);
          for (let key in newForm) {
            let str = newForm[key];
            if (str instanceof Array) {
              newForm[key] = str.join("/");
            }
          }
          if (
            this.formColumn[0]&&this.formColumn[0].groupName == "入职信息" &&
            this.form.dutyStatus == "3" &&
            !this.form.dimissionDate
          ) {
            this.$message.error("请选择离职时间！");
            return;
          }
          let arr = newForm.promotionCategory.split("/")
          newForm.promotionCategory=arr.join("、");
        
          let params = {
            tenantGuid: this.$store.state.guid,
            rosterParam: this.fileHanlde(newForm),
            staffRecordTenantGuid: newForm.sendTenantGuid,
            staffGuid: userInfo.staffGuid,
          };

          if (this.guid) {
            params["guid"] = this.guid;
          }
          this.$emit("updateLading");
          this.api
            .put(
              `/${serverConfig.msPersonnelService}/staff-roster/save-or-update`,
              params
            )
            .then((res) => {
              this.$emit("updateLading");
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                this.$message.success("保存成功！");
                this.$emit("updateIsEdit", { guid: res.data.data.guid });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
      });
    },
    saveOneForm() {
      let newForm = null;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          newForm = JSON.parse(JSON.stringify(this.form));
          for (let key in newForm) {
            let str = newForm[key];
            if (str instanceof Array) {
              newForm[key] = str.join("/");
            }
            newForm.entryDate = newForm.entryDate
              ? newForm.entryDate.substr(0, 10)
              : null;
          }
          if (
            this.formColumn[0]&&this.formColumn[0].groupName == "入职信息" &&
            this.form.dutyStatus == "3" &&
            !this.form.dimissionDate
          ) {
            this.$message.error("请选择离职时间！");
            return;
          }
        }
        this.newForm = newForm;
      });
    },
    /** 移除表单项的校验结果 */
    clearValidate() {
      this.$refs["ruleForm"].resetFields();
    },
    // 图片、文件上传及预览------------
    //预览图片
    getPreviewList(fieldName) {
      let obj = JSON.parse(this.form[fieldName]);
      this.previewList = [obj.path];
    },
    //执行上传
    uploadImage(file, fieldName) {
      console.log(file, fieldName, "ljx");
      let formData = new FormData();
      formData.append("image", file.file);
      this.api
        .postImage(this.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let obj = {
              fileName: file.file.name,
              path: res.data.data,
            };
            this.form[fieldName] = JSON.stringify(obj);
            let str = "uploadImg_" + fieldName;
            this.$refs[str][0].clearFiles();
            this.$message.success("上传成功");
          } else {
            this.$message.error("上传失败,请重新上传!");
          }
        })
        .catch(() => {
          this.$message("上传失败,请重新上传");
        });
    },
    //上传前校验
    beforeAvatarUpload(file) {
      let testmsg = file.name ? file.name.split(".")[1] : "";
      const isJPG =
        testmsg === "jpeg" ||
        testmsg === "png" ||
        testmsg === "jpg" ||
        testmsg === "pdf" ||
        testmsg === "doc" ||
        testmsg === "docx" ||
        testmsg === "xls" ||
        testmsg === "xlsx" ||
        testmsg === "xlsm";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("文件格式不正确!");
      }
      if (!isLt2M) {
        this.$message.error("文件大小不能超过2MB!");
      }
      return isJPG && isLt2M;
    },
    //文件的上传
    //问价上传成功与否
    uploadFileOther(file, fileName) {
      let self = this;
      let formData = new FormData();
      formData.append("image", file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              path: res.data.data,
            };
            // 得到对应上传字段的 _arr 自己定义字段名
            const str_tmp = fileName + "_arr";
            if (!self.form[str_tmp]) {
              self.form[str_tmp] = [];
            }
            self.form[str_tmp].push(item);

            self.form[fileName] = JSON.stringify(self.form[str_tmp]);
            console.log(555, self.form[fileName]);
            self.$message.success("上传成功");
          } else {
            self.$message.error("上传失败,请重新上传!");
          }
        })
        .catch((err) => {
          console.dir(err);
          self.$message("上传失败,请重新上传");
        });
    },
    //上传限制
    beforeAvatarUploadOther(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过 20MB!`,
          type: "warning",
        });
      }
      return isLt2M;
    },

    //处理上传文件的个数
    handleFileRemoveOther(file, fileName) {
      let self = this;
      // let tmp = JSON.parse(self.form[fileName])
      // tmp.forEach(function (j, ind) {
      //   if (j.path == file.path) {
      //     tmp.splice(ind, 1);
      //   }
      // });
      console.log(444, self.form[fileName]);
    },
    //展示文件
    onPreview(fileName) {
      const obj = JSON.parse(this.form[fileName]);
      console.log(1123, obj);
      //照片
      var fileSuffix = obj[0].name
        ? obj[0].name.substring(obj[0].name.lastIndexOf(".") + 1)
        : "";
      if (
        fileSuffix === "png" ||
        fileSuffix === "jpeg" ||
        fileSuffix === "jpg" ||
        fileSuffix === "pdf"
      ) {
        return window.open(obj[0].path, obj[0].name);
      }
      //world和Excel下载.png.jpeg.jpg.pdf
      window.open(
        "https://view.officeapps.live.com/op/view.aspx?src=" + obj[0].path
      );
    },
    //下载文件
    onDownload(fileName) {
      console.log(fileName);
      const obj = JSON.parse(this.form[fileName]);
      window.open(
        obj[0].path + "?response-content-type=application/octet-stream"
      );
    },
    //删除
    handleSubRemove(file, fileName) {
      console.log(file, fileName);
      const obj = JSON.parse(this.form[fileName]);
      console.log(obj);
      obj.forEach((item, index) => {
        if (file.name === item.name) {
          obj.splice(index, 1);
          this.form[fileName] = JSON.stringify(obj);
        }
      });
      const str_tmp = fileName + "_arr";
      this.form[str_tmp] = obj;
      //暴力刷新
      this.$forceUpdate();
    },
    changeDropdown(item, value) {
      console.log(item, value);
      this.$emit("dynamicModification", { item, value, index });
      this.$emit("dynamicModifications", { item, value, index });
    },
    // currentFormData(fileName) {
    //   console.log(1131, this.form[fileName]);
    //   if (this.form[fileName]) {
    //     return JSON.parse(this.form[fileName])
    //   }
    //   return []
    // }
  },
};
</script>

<style>
.import-step-tip{
  font-size: 12px;
  color: #999;
}
.el-collapse-item__content{
  padding: 0px;
}
.my-textarea {
  margin-right: 20px;
}

::v-deep .fieldItemClass .el-form .el-form-item .el-form-item__label {
  width: 0;
  margin-left: 40px;
}
</style>
<style scoped>
.file-operate {
  display: flex;
}
::v-deep .el-input .el-input__inner {
  color: #212121 !important;
}
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
  width: 28px;
}

.fieldItemClass {
  padding: 10px 0;
}

.fieldItemClass /deep/ .el-form .el-form-item {
  min-height: 44px;
  display: flex;
  align-items: center;
}

.fieldItemClass /deep/ .el-form .el-form-item .el-form-item__label {
  width: 21%;
  line-height: 22px;
}

.fieldItemClass /deep/ .el-form .el-form-item .el-form-item__content {
  display: inline-block;
  width: 79%;
}

.fieldItemClass
  /deep/
  .el-form
  .el-form-item
  .el-form-item__content
  .el-select {
  width: 100%;
}

.fieldItemClass
  /deep/
  .el-form
  .el-form-item
  .el-form-item__content
  .el-select
  .el-input__prefix {
  left: auto;
  right: 5px;
}

.fieldItemClass /deep/ .el-form .el-form-item .el-form-item__content .el-input {
  width: 100%;
}

.fieldItemClass
  /deep/
  .el-form
  .el-form-item
  .el-form-item__content
  .el-select
  .el-input
  .el-input__inner {
  padding-left: 15px;
}

/* 多行 radio checkbox 宽度不勾换行 */
.fieldItemClass /deep/ .el-form .el-radio-group label {
  line-height: 32px;
}

.dialog-form {
  /* margin: 0 50px 0 10px; */
}

.disabled-cl {
  color: #c0c4cc !important;
}

.icon-hover:hover .el-icon-search {
  display: none;
}

.not-show {
  display: none;
}

.dict-item {
  display: inline-block;
  width: 150px;
  overflow: hidden;
  margin-right: 8px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* 上传图片 */
.avatar-uploader {
  text-align: left;
}

.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.previewImg {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 80px;
  height: 80px;
  display: block;
}

.el-form .dialog-form .el-col-12 {
  width: 33%;
}
.import-btn-tips {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.file-operate .file-name {
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fileClass {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
